const CONVERSION_ID = "AW-18116515971";

const REGISTRATION_LABEL = import.meta.env.VITE_GOOGLE_ADS_REGISTRATION_LABEL as
  | string
  | undefined;
const PURCHASE_LABEL = import.meta.env.VITE_GOOGLE_ADS_PURCHASE_LABEL as
  | string
  | undefined;

const FIRED_STORAGE_KEY = "gestionalo.gads.fired";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function isReady(): boolean {
  if (!import.meta.env.PROD) return false;
  if (typeof window === "undefined") return false;
  return typeof window.gtag === "function";
}

function markFired(scope: string): boolean {
  try {
    const stored = sessionStorage.getItem(FIRED_STORAGE_KEY) ?? "";
    const tokens = stored ? stored.split(",") : [];
    if (tokens.includes(scope)) return false;
    tokens.push(scope);
    sessionStorage.setItem(FIRED_STORAGE_KEY, tokens.join(","));
    return true;
  } catch {
    return true;
  }
}

export function fireRegistrationConversion(): void {
  if (!isReady() || !REGISTRATION_LABEL) return;
  if (!markFired("registration")) return;
  window.gtag!("event", "conversion", {
    send_to: `${CONVERSION_ID}/${REGISTRATION_LABEL}`,
  });
}

export function firePurchaseConversion(params: {
  transactionId: string;
  value?: number;
  currency?: string;
}): void {
  if (!isReady() || !PURCHASE_LABEL) return;
  if (!markFired(`purchase:${params.transactionId}`)) return;
  window.gtag!("event", "conversion", {
    send_to: `${CONVERSION_ID}/${PURCHASE_LABEL}`,
    transaction_id: params.transactionId,
    value: params.value,
    currency: params.currency ?? "UYU",
  });
}
